module.exports = __webpack_public_path__ + "static/media/unibest-problem.c2be2598.png";